module.exports = {
  language: 'Indonesian',
  nationalityKay: 'id-id',
  personal: {
    purgePopupContent:
      'Maaf, data lamaran Anda telah dihapus karena kebijakan keamanan, Anda dapat menghubungi kami jika ingin segera melamar'
  },
  login_maximum: {
    errorContent: 'Maaf Anda telah mencapai waktu login maksimum hari ini, silakan coba keesokan harinya.'
  },
  noneSelectedText: 'Silakan pilih',
  multiselect: {
    deselect: 'Tekan enter untuk menghapus',
    select: 'Tekan enter untuk memilih',
    selected: 'Terpilih'
  },
  enter: 'Memasuki',
  upload_failed: 'Pengunggahan gagal, harap coba lagi',
  due_time: 'Waktunya',
  requirement: 'Persyaratan',
  something_went_wrong_please_retry: 'Terjadi kesalahan, silakan coba lagi.',
  valid_rediret_home_page_popup_content:
    "Terjadi pengecualian login. Apakah Anda mencoba membuka halaman beranda [ {country} - {center} ] untuk masuk? Jika ya, silakan klik 'Konfirmasi'; jika tidak, silakan klik 'Batal' untuk memilih lagi.",
  invalid_rediret_home_page_popup_content: 'Terjadi pengecualian login, pilih negara dan lokasi untuk melanjutkan.',
  'Temporarily not available': 'Untuk sementara tidak tersedia',
  'Coming soon': 'Segera'
};
